export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS 2022.9b3d97c9.pdf";